import 'library-@/directives/mathJax-paper/math.directive.js';
import getParams from 'library-@/utils/get-params.js';
import { headerService } from '@/services/header-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PatentBasicService } from '@/domains/patent/services/patent-basic-service';
import { startupView } from './startup-view';
import { startupFreeView } from './startup-free-view';
import { prepareToken } from './prepare-token';
import type { InitParams, CommonInitData, LegalConfig } from '../types';

export async function initialize({ beforeInit, forceSetLocale }: InitParams = {}) {
    const urlParams: Record<string, string> = getParams();
    const patentId = urlParams.patentId;

    // @ts-ignore
    let commonInitData: CommonInitData = { globalConfig: {} };
    let locale = '';
    let legalConfig: LegalConfig = { legalConfig: [] };

    // 主动调用 prepareToken 区分是否登录
    const { isFreeView, viewInitData } = await prepareToken(urlParams);

    // 已经 prepareToken 过了, 后续调用startup时候不再做 prepareToken 动作
    if (isFreeView) {
        ({ commonInitData, locale, legalConfig } = await startupFreeView(forceSetLocale));
    } else {
        // 初始化之前执行
        if (beforeInit) await beforeInit();
        ({ commonInitData, locale, legalConfig } = await startupView(forceSetLocale));
    }

    if (patentId && !isFreeView) {
        const patentBasicService = injectService<PatentBasicService>(PatentBasicService);
        patentBasicService.getPatentBase(patentId);
    }

    return {
        viewInitData: viewInitData || {},
        globalConfig: commonInitData.globalConfig,
        locale,
        headerService,
        legalConfig: legalConfig.legalConfig,
        isFreeView,
    };
}
